<template>
<div class="chapter">
<div class="inner_page">
<div id="dedication">
<p class="center"><a id="page5"></a><em>for Maia, Alba, and Eva</em></p>
<div class="images">
<p class="center"><a id="page2"></a><img alt="Morocco" src="images/title.jpg" width="100%"/></p>
</div>
<div class="images" id="image4">
<p class="center"><img alt="Morocco" src="images/img-4.jpg" width="100%"/></p>
</div>
<div class="images" id="image2">
<p class="center"><a id="page1"></a><img alt="Morocco" height="100%" src="images/img-1.jpg"/></p>
</div>
<div class="images" id="image5">
<p class="center"><img alt="Morocco" height="100%" src="images/img-6.jpg"/></p>
</div>
<div class="images" id="image6">
<p class="center"><a id="page7"></a><img alt="Morocco" height="100%" src="images/img-7.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004dedication.vue?c6c74638